export const sampleData: ArrayBuffer | undefined = undefined;
